export const SITE = {
  brand: "FREE MAN",
  brandDisplay: "Free Man",
  artist: "Wild Thing",
  edition: "Wild Thing 〈Free Man〉",
  editionLabel: "野東西限定珍藏香氛",
  tagline: "音樂是野的，味道也是",
  productName: "Free Man",
  price: 1580,
  priceLabel: "NT$1,580",
  limitLabel: "全球限量珍藏香氛",
  volume: "10 ml Eau de Parfum",
  shipping: 0,
  email: "info@mrearmusic.com",
  phone: "02-77094888",
  logo: "https://static.lumi.new/90/90780d3e0e5e5c46f70ed4649948fe40.webp",
  hero: "https://static.lumi.new/56/566fd7e7f41f6e16213b2a24bb932bfc.webp",
  heroMobile: "https://static.lumi.new/af/af5392d2e47345e49324ee7d6e557d9c.png",
  music: "https://static.lumi.new/5b/5b3563c1fb7df18ef0ce83e251c3938e.webp",
  editionBg: "https://static.lumi.new/7d/7daa298e2af4fd7d761f14f7835f93d2.webp",
  productMain: "https://static.lumi.new/26/26e8776e398a941db946df97326aa484.webp",
  productAlt: "https://static.lumi.new/99/99f1073a46c83b2abb6f06303956bd4f.webp",
  closingMark: "https://static.lumi.new/c5/c54782dcca54dc7b61efc2913deb2e0b.webp",
}

export const BANK = [
  { label: "銀行代碼", value: "822" },
  { label: "銀行名稱", value: "中國信託商業銀行" },
  { label: "戶名", value: "零加壹文創整合有限公司" },
  { label: "帳號", value: "303540352643" },
]
